import EN_US from '../translations/en-us'
import FR from '../translations/fr'
import DE from '../translations/de'
import ES from '../translations/es'
import NL from '../translations/nl'
import IT from '../translations/it'
import NO from '../translations/no'
import RU from '../translations/ru'
import PT from '../translations/pt'
import PL from '../translations/pl'
import KO from '../translations/ko'
import JA from '../translations/ja'
import ZH from '../translations/zh'
import CS from '../translations/cs'
import TR from '../translations/tr'

export default {
    "en-us":{
        message: EN_US
    },
    fr:{
        message: FR
    },
    de:{
        message: DE
    },
    es:{
        message: ES
    },
    nl:{
        message: NL
    },
    it:{
        message: IT
    },
    no:{
        message: NO
    },
    ru:{
        message: RU
    },
    pt:{
        message: PT
    },
    pl:{
        message: PL
    },
    ko:{
        message: KO
    },
    ja:{
        message: JA
    },
    zh:{
        message: ZH
    },
    cs:{
        message: CS
    },
    tr:{
        message: TR
    }
}